/**
 * 主业务 axios 实例
 * 功能：请求带 token 与 NProgress 进度条，响应 code!=200 弹错误、10000-10003 清 token 跳 403，URL 含 exportCsv 时强制 blob
 */
import axios from "axios";
import router from "../router/index";
import ElementUI from 'element-ui';
import {
  getToken,
  removeToken
} from "./cookies"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
//设置下载接口名单
const BlobTypeList = ["exportCsv"];
// 创建axios实例
const service = axios.create({
  withCredentials: true,
  baseURL: process.env.publicPath,
});
//request拦截器
service.interceptors.request.use(config => {
  config.headers["Accept"] = "application/json,text/javascript, */*; q=0.01";
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  axios.defaults.withCredentials = true;
  NProgress.start();
  if (isBlob(config.url)) {
    config.responseType = 'blob'
  }
  var token = getToken()
  if (token) {
    config.headers["X-CSRF-TOKEN"] = token;
    return config
  }
  //跳转到登陆页面
  router.push("/403")
  return config;
},
  error => {
    Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(response => {
  let {
    code,
    msg,
    data
  } = response.data
  if (code && code != 200) {
    if (code == 10000 || code == 10001 || code == 10002 || code == 10003) {
      removeToken();
      //关闭此页面 重新登陆
      router.push({
        path: "/403"
      })
    }
    ElementUI.Message({
      dangerouslyUseHTMLString: true,
      message: data || msg,
      type: 'error'
    });
  }
  NProgress.done();
  return response.data;
}, error => {
  if (error.response) {
    const res = error.response.data;
    if (error.response.status && error.response.status !== 200) {
      switch (error.response.status) {
        case 404:
          ElementUI.Message({
            message: "系统更新中，请稍后！",
            type: 'error'
          });
          break;
        default:
          if (error.response.data.data) {
            ElementUI.Message({
              message: error.response.data.data,
              type: 'error'
            });
          } else {
            ElementUI.Message({
              message: "系统更新中，请稍后！",
              type: 'error'
            });
          }
          break;
      }
      return Promise.reject(res);
    }
  } else {
    return Promise.reject(error);
  }
});

/** 判断请求 URL 是否属于下载接口（需要 blob 响应） */
function isBlob(url) {
  for (let index = 0; index < BlobTypeList.length; index++) {
    const element = BlobTypeList[index];
    if (url.indexOf(element) !== -1) {
      return true;
    }
  }
  return false
}
export default service;